import type { TOC } from '@ember/component/template-only';
import { LinkTo } from '@ember/routing';
import { local } from 'embroider-css-modules';

import styles from '../breadcrumb.module.css';

interface PrismBreadcrumbItemSignature {
  Args:
    | {
        isCurrent: true;
        label: string;
      }
    | {
        isCurrent?: false;
        label: string;
        route: string;
      };
}

const PrismBreadcrumbItem = <template>
  <li class={{styles.list-item}}>
    {{#if @isCurrent}}
      <span
        class={{local styles "label" "is-current"}}
        data-test-breadcrumb-item={{@label}}
      >
        {{@label}}
      </span>
    {{else}}
      <LinkTo
        @route={{@route}}
        class="prism-link prism-link--secondary prism-link--standalone"
        data-test-breadcrumb-item={{@label}}
      >
        <span class={{styles.label}}>
          {{@label}}
        </span>
      </LinkTo>
    {{/if}}
  </li>
</template> satisfies TOC<PrismBreadcrumbItemSignature>;

export default PrismBreadcrumbItem;
